import React from "react";
import { Container } from "./styled/wrapper";

function Wrapper(props) {
  return <Container {...props} />;
}

export default Wrapper;
